var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1275"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 831"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 38",
    d: "M18.3643 10.2894C18.3643 11.9749 17.6158 14.7584 16.3666 17.1293C15.7461 18.3069 15.0253 19.3372 14.2542 20.063C13.4796 20.7922 12.7186 21.1564 11.9986 21.1564C11.2785 21.1564 10.5175 20.7922 9.74286 20.063C8.97185 19.3372 8.25101 18.3069 7.63049 17.1293C6.38131 14.7584 5.63281 11.9749 5.63281 10.2894C5.63281 7.06628 8.43618 4.37158 11.9986 4.37158C15.5609 4.37158 18.3643 7.06628 18.3643 10.2894Z",
    stroke: "#A0A0A0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 39",
    d: "M15.4129 11.0227C15.4129 12.7201 13.9295 14.1778 11.9955 14.1778C10.0615 14.1778 8.57812 12.7201 8.57812 11.0227C8.57812 9.32543 10.0615 7.86768 11.9955 7.86768C13.9295 7.86768 15.4129 9.32543 15.4129 11.0227Z",
    stroke: "#A0A0A0",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8b69c65a43d0b674a4c1bb167188b7e7.svg";
export { ForwardRef as ReactComponent };